import HelperTable from "../common/HelperTable";

export function tableWorker(HelperTable) {

    const selectorTable = '#table-worker';
    const elTable = $(selectorTable)

    if (!elTable.length) {
        return;
    }

    const canEditOther = ESR.Helper.canEditOther();
    const canViewReports = ESR.Helper.userCan('view_reports');

    const callbackTableColHeadWorkers = (data, type, row) => {
        let html = '';
        let counter = 0;

        row?.workers.forEach(worker => {
            const title = canEditOther ? `<span title="${worker.coef}">${worker.name}</span>` : worker.name;
            html += counter === 0 ? '' : ' <span>,</span> ';
            html += title;
            counter++;
        });

        return html;
    }

/// TODO MOVE IN HELPER and Replace here and in report-project




    let columns = [];


    columns = [
        {
            label: ESR.lang.id,
            data: 'id',
            className: 'id min-tablet-p',
            visible: true
        },
        {
             label: ESR.lang.project_title,
            data: 'post_title',
            className: 'post_title min-mobile',
            visible: true,
            orderable: true,
            render: function (data, type, row) {
                if (type === 'display') {
                    return row.post_title;
                } else if (type === 'filter') {
                    return row.post_id;
                }

                return data;
            }
        },
        {
             label: ESR.lang.service_title,
            data: 'service_title',
            className: 'service_title min-mobile',
            visible: true,
            orderable: false
        },
        {
            label: ESR.lang.date,
            data: 'date',
            name: 'date',
            className: 'date min-mobile',
            visible: true,
            orderable: true
        },
        {
            label: ESR.lang.qty,
            data: 'qty',
            className: 'qty min-tablet',
            visible: true,
            orderable: false
        },
        {
            label: ESR.lang.unit,
            data: 'unit',
            className: 'unit min-tablet',
            visible: true,
            orderable: false
        },
        {
            label: 'Ore (e)',
            data: 'hours',
            className: 'hours-e min-tablet',
            visible: true,
            orderable: true,
            render: HelperTable.renderColumnHoursEntry
        },
        {
            label: 'Ore (s)',
            data: null,
            className: 'hours-s min-tablet',
            visible: true,
            render: HelperTable.renderColumnHoursStandard
        },
        {
            label: 'Ore (dif)',
            data: null,
            className: 'hours-dif min-tablet',
            visible: true,
            render: (data, type, row) => {
                const value = HelperTable.calculateDiffHours(row);

                if (type === 'display' || type === 'filter') {
                    return ESR.Helper.formatDecimal( value );
                }

                return value; // Returnează valoarea pentru totaluri
            }
        },
    ];

    if (canViewReports) {
        columns.push({
            label: ESR.lang.price,
            data: 'price',
            className: 'price min-tablet',
            visible: false,
            orderable: true
        })
        columns.push({
            label: ESR.lang.price_a_all,
            data: 'price_a',
            className: 'price_a',
            visible: false
        })
    }

    columns = [
        ...columns,
        {
            label: ESR.lang.workers,
            data: 'workers',
            className: 'workers',
            orderable: false,
            render: callbackTableColHeadWorkers,
            visible: false
        },
        {
            label: ESR.lang.created,
            data: 'created',
            className: 'created',
            visible: false
        },
        {
            label: ESR.lang.updated,
            data: 'updated',
            className: 'updated',
            visible: false
        },
        {
            label: ESR.lang.author,
            data: 'modified_name',
            className: 'moderator',
            visible: false,
            orderable: true
        },
        {
            label: 'Preț (1 unit)',
            data: 'service_price_a',
            className: 'service_price_a',
            visible: false,
            orderable: true
        },
        {
            label: 'Ore (1 unit)',
            data: 'service_hours',
            className: 'service_hours',
            visible: false,
            orderable: true
        }
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    const myTableFooter = HelperTable.createRowFooterEmpty(columns)
    elTable.append(myTableHeader)
    elTable.append(myTableFooter)

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        order: [
            [3, 'dsc']
        ],
        stateSave: true,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            // topStart: toolbar,
            topStart: {
                buttons: [
                    // 'pageLength',
                    {
                        extend: 'colvis',
                        className: 'btn btn-sm btn-neutral',
                    },
                    {
                        extend: 'collection',
                        text: ESR.lang.export,
                        className: 'btn btn-sm btn-neutral btn-export',
                        buttons: [
                            {
                                extend: 'excelHtml5',
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            },
                            {
                                extend: 'pdf',
                                text: 'PDF',
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            },
                            {
                                extend: 'print',
                                text: ESR.lang.print,
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            }
                        ]
                    },

                ]
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
            buttons: {
                // colvis: 'Coloane',
            }
        },
        displayLength: 100,
        footerCallback: function (tfoot) {
            if (!canViewReports) return;

            let api = this.api();
            const settings = api.settings().init();
            const elColHeader = api.columns('th').header();

            let indexColVolum, indexColPrice, indexColPriceA, indexColMinE, indexColMinS, indexColMinDif;

            // Iterate through the headers to find column indices
            elColHeader.each(function (v, k) {
                const item = $(v);
                if (item.is(":visible")) {
                    if (item.hasClass('qty')) indexColVolum = k;
                    if (item.hasClass('price')) indexColPrice = k;
                    if (item.hasClass('price_a')) indexColPriceA = k;
                    if (item.hasClass('hours-e')) indexColMinE = k;
                    if (item.hasClass('hours-s')) indexColMinS = k;
                    if (item.hasClass('hours-dif')) indexColMinDif = k;
                }
            });

            // Funcție pentru calculul totalurilor din datele filtrate
            const calculateColumnTotal = (columnIndex, calculationFn = null) => {
                if (columnIndex === undefined) return 0;

                let total = 0;
                api.rows({search: 'applied'}).every(function (rowIdx, tableLoop, rowLoop) {
                    const rowData = this.data();

                    if (calculationFn) {
                        // Pentru coloanele calculate (Ore (s) și Ore (dif))
                        total += calculationFn(rowData);
                    } else {
                        // Pentru coloanele cu date directe
                        const cellData = api.cell(rowIdx, columnIndex).data();
                        total += ESR.Helper.toFloat(cellData);
                    }
                });

                return total;
            };

            // Actualizare totaluri
            if (indexColVolum !== undefined) {
                const totalQty = calculateColumnTotal(indexColVolum);
                $(api.column(indexColVolum).footer()).html(ESR.Helper.formatNumber(totalQty, 2));
            }

            if (indexColMinE !== undefined) {
                const totalMinE = calculateColumnTotal(indexColMinE);
                $(api.column(indexColMinE).footer()).html(ESR.Helper.formatNumber(totalMinE, 2));
            }

            if (indexColMinS !== undefined) {
                const totalMinS = calculateColumnTotal(null, HelperTable.calculateStandardHours);
                $(api.column(indexColMinS).footer()).html(ESR.Helper.formatNumber(totalMinS, 2));
            }

            if (indexColMinDif !== undefined) {
                const totalMinDif = calculateColumnTotal(null, HelperTable.calculateDiffHours);
                $(api.column(indexColMinDif).footer()).html(ESR.Helper.formatNumber(totalMinDif, 2));
            }

            if (indexColPrice !== undefined) {
                const totalPrice = calculateColumnTotal(indexColPrice);
                $(api.column(indexColPrice).footer()).html(totalPrice);
            }

            if (indexColPriceA !== undefined) {
                const totalPriceA = calculateColumnTotal(indexColPriceA);
                $(api.column(indexColPriceA).footer()).html(totalPriceA);
            }
        }
    });


}